'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _showController = require('./show.controller');

var _showController2 = _interopRequireDefault(_showController);

var _showHtml = require('./show.html');

var _showHtml2 = _interopRequireDefault(_showHtml);

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider.state('app.private.waybill.show', {
		controller: _showController2['default'],
		template: _showHtml2['default'],
		'controllerAs': 'vm',
		'url': '/show?busId&date&seats',
		'resolve': {
			'Waybill': function Waybill($filter, $stateParams, $state, BusComponent, Toast) {
				'ngInject';

				return BusComponent.fetchWaybill($stateParams.busId, $stateParams.date).then(function (res) {
					if (res.data && res.data.errors) {
						Toast.responseError(res.data.errors);
						$state.go('app.private.waybill.chooseBus');
					} else if (res.data.data && !res.data.data.seats.length) {
						Toast.error($filter('translate')('NOT_FOUND.SOLD_TICKETS'));
						$state.go('app.private.waybill.chooseBus');
					} else {
						return res.data.data;
					}
				});
			}
		}
	});
}

exports['default'] = RouteConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/waybill/show/show.route.js
 **/